import jwt_decode from 'jwt-decode'
import { useSelector, useDispatch } from 'react-redux'
import { userLogut } from '../redux/actions/authActions'
import { decryptText } from './crypto'
const useAuth = () => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.authReducer)
  let token = user?.token
  if (!token) {
    return false
  }
  const payload = {
    userId: user?.userId,
    isActive: user?.isActive,
    userName: user?.userName,
  }
  try {
    const isEncrypted = process.env.REACT_APP_ENCRYPT_ACCESS_TOKEN === 'true';
    const decryptedToken = isEncrypted ? decryptText(token,true) : token;
    const decoded = jwt_decode(decryptedToken)
    if (decoded.exp * 1000 < Date.now()) {
      dispatch(userLogut(payload))
      return false
    } else {
      return true
    }
  } catch (err) {
    dispatch(userLogut(payload))
    return false
  }
}

export default useAuth
